var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4773 5.10672L19.396 1.02484C18.7359 0.368703 17.8445 0 16.9203 0H8.75C6.81953 0 5.25 1.5668 5.25 3.5L5.25054 19.25C5.25054 21.1827 6.81733 22.75 8.75054 22.75H21.0005C22.925 22.75 24.5 21.175 24.5 19.25V7.57969C24.5 6.65547 24.1336 5.76406 23.4773 5.10672ZM21.875 19.25C21.875 19.7332 21.4832 20.125 21 20.125H8.75C8.26667 20.125 7.875 19.7332 7.875 19.25V3.50711C7.875 3.02389 8.26678 2.63211 8.75 2.63211H15.75V7C15.75 7.96633 16.5337 8.75 17.5 8.75H21.8745V19.25H21.875ZM17.9375 28H6.5625C2.94383 28 0 25.0578 0 21.4375V6.5625C0 5.84063 0.587891 5.25 1.3125 5.25C2.03711 5.25 2.625 5.84063 2.625 6.5625V21.4375C2.625 23.6086 4.39141 25.375 6.5625 25.375H17.9375C18.6621 25.375 19.25 25.9629 19.25 26.6875C19.25 27.4121 18.6648 28 17.9375 28Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticles);
export default __webpack_public_path__ + "static/media/articles.dc87e6b42c275031507383665ca66001.svg";
export { ForwardRef as ReactComponent };